import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'

export const operationLinkClassName = ({
  isInteractive,
  isDraft,
}: {
  isInteractive: boolean
  isDraft: boolean
}) =>
  cx(
    'flex w-full flex-wrap min-w-0 shrink justify-between rounded-lg border px-2 gap-x-2 py-0.5 font-medium',
    paperStyles({ borders: ['all'] }),
    { 'border-draft-600! dark:border-draft-400!': isDraft },
    { 'hover:opacity-90': isInteractive },
  )
